import { appConfig } from '@/shared/config/app-config';

export type VerifyEmailResult = { ok: true } | { ok: false; code: 'EXPIRED' | 'UNKNOWN' };

export async function verifyEmail(token: string): Promise<VerifyEmailResult> {
    let response: Response;
    try {
        response = await fetch(`${appConfig.apiUrl}/auth/verify-email`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        });
    } catch {
        return { ok: false, code: 'UNKNOWN' };
    }

    if (response.ok) {
        return { ok: true };
    }

    if (response.status === 410) {
        return { ok: false, code: 'EXPIRED' };
    }

    return { ok: false, code: 'UNKNOWN' };
}
